import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";

const SECTIONS = [
  {
    title: "1. Titolare del trattamento",
    body: "Il titolare del trattamento dei dati personali è Nicola Verardo, contattabile all'indirizzo email verardonicola@gmail.com.",
  },
  {
    title: "2. Dati raccolti",
    body: "Attraverso il modulo contatti vengono raccolti: nome, indirizzo email, azienda (facoltativo), tipo di progetto e contenuto del messaggio. La navigazione del sito non comporta la raccolta di dati personali ulteriori.",
  },
  {
    title: "3. Finalità e base giuridica",
    body: "I dati sono trattati esclusivamente per rispondere alla richiesta inviata tramite il modulo (art. 6, par. 1, lett. b del GDPR — esecuzione di misure precontrattuali). Non vengono inviate newsletter, non viene effettuata profilazione e i dati non vengono ceduti né venduti a terzi.",
  },
  {
    title: "4. Conservazione",
    body: "I messaggi ricevuti sono conservati per il tempo necessario a gestire la richiesta e, in caso di collaborazione non avviata, comunque non oltre 24 mesi dall'ultimo contatto.",
  },
  {
    title: "5. I tuoi diritti",
    body: "Puoi chiedere in qualsiasi momento l'accesso, la rettifica, la cancellazione, la limitazione del trattamento o opporti allo stesso (artt. 15–22 GDPR) scrivendo a verardonicola@gmail.com. Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
  },
  {
    title: "6. Cookie",
    body: "Questo sito non utilizza cookie di profilazione né strumenti di tracciamento pubblicitario. Sono presenti unicamente strumenti tecnici necessari al funzionamento delle pagine.",
  },
  {
    title: "7. Modifiche a questa informativa",
    body: "Eventuali aggiornamenti di questa informativa saranno pubblicati su questa pagina con indicazione della data di revisione.",
  },
];

const Privacy = () => {
  return (
    <main data-testid="privacy-page" className="bg-night pt-32 min-h-screen">
      <Seo
        title="Privacy Policy — Nicola Verardo"
        description="Informativa sul trattamento dei dati personali raccolti tramite il modulo contatti di nicolaverardo.it."
        path="/privacy"
        noindex
      />
      <div className="px-6 sm:px-12 lg:px-20 pb-24 max-w-3xl">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-fog">Privacy</p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-normal tracking-tight text-bone">Privacy Policy</h1>
          <p className="mt-4 text-[10px] font-mono tracking-[0.25em] text-fog/60 uppercase">Ultimo aggiornamento — Ottobre 2026</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((section) => (
            <Reveal key={section.title} delay={60}>
              <h2 className="text-base md:text-lg text-bone tracking-tight">{section.title}</h2>
              <p className="mt-3 text-sm text-fog leading-relaxed">{section.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Privacy;
